import { useMemo } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished, getIsPublishing, getIsArchived, getIsFullySignedPaidOrProcessing } from 'quotes-ui-lib/utils/status';
import { getHasDeal } from 'quotes-ui-lib/utils/utils';
import { hasDeprecatedTemplateType as getHasDeprecatedTemplateType } from 'quotes-ui-lib/utils/templates';
import { jsx as _jsx } from "react/jsx-runtime";
const RecallAndEditButton = ({
  quote,
  onClick
}) => {
  const hasDeal = getHasDeal(quote);
  const hasDeprecatedTemplateType = getHasDeprecatedTemplateType(quote);
  const isFullySignedPaidOrProcessing = getIsFullySignedPaidOrProcessing(quote);
  const disabledTooltipTitleKey = useMemo(() => {
    let translationKey = '';
    if (isFullySignedPaidOrProcessing) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.recallSignedTooltip';
    } else if (!hasDeal) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.noDealTooltip';
    } else if (hasDeprecatedTemplateType) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.deprecatedTemplateTooltip';
    }
    return translationKey;
  }, [isFullySignedPaidOrProcessing, hasDeal, hasDeprecatedTemplateType]);
  const disableButton = !!disabledTooltipTitleKey;
  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledTooltipTitleKey
    }),
    disabled: !disableButton,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "recall-quote-btn",
      "data-selenium-test": "recall-quote-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: handleButtonClick,
      disabled: disableButton,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "recall-quote-btn-text",
        message: "quotesUiLib.quoteActions.recallAndEdit.buttonText"
      })
    }, "recallButton")
  }, "recall");
};
export const showRecallAndEditButton = (quote, canCurrentUserEditQuote) => {
  const isPublished = getIsPublished(quote);
  const isPublishing = getIsPublishing(quote);
  const isArchived = getIsArchived(quote);
  const isRecallable = isPublished && !isArchived || isPublishing;
  return canCurrentUserEditQuote && isRecallable;
};
export default RecallAndEditButton;